module.exports = __webpack_public_path__ + "img/diners-club.e8158bee.svg";